module.exports = __webpack_public_path__ + "img/cl_without_content.e205465d.png";